import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import ikoRatings from "../../../../src/data/articles/cube-prospective-ikoria-lair-of-behemoths/iko-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  ikoRatings,
  ProspectiveIntro,
  React
};